<template>
    <div
        class="relative home-marketing-section pt-10 pb-32 px-2 lg:px-20 bg-cover"
    >
        <div
            class=" max-w-screen-2xl mx-auto flex flex-col md:flex-row items-center justify-between md:px-6"
        >
            <h3
                class="font-primary text-4xl text-white text-center sm:text-left"
                v-html="$config('MULTIPLATFORM')"
            ></h3>

            <app-image
                width="666"
                height="431"
                url="multiplataforma-new.png"
                is-local
                :try-webp="false"
                class="w-full md:w-2/3 xl:w-7/12"
                alt="App multiplataforma"
            >
            </app-image>
        </div>
        <div class="items-center">
            <SpriteAnim
                v-if="!$isMobile()"
                id="senalandoTop"
                :json="
                    require('../assets/animations/panchito_top_right-min.json')
                "
                :png="
                    require('../assets/animations/panchito_top_right-min.png')
                "
                :fps="24"
            />
            <app-image
                v-if="$isMobile()"
                :url="
                    require('../assets/animations/panchito_top_right_fallback-min.png')
                "
                :is-local="false"
                alt="Linea de tiempo precio"
                class="m-auto"
                style="margin-bottom: -150px;"
                width="250"
                height="250"
                :tryWebp="false"
            >
            </app-image>
        </div>
    </div>
</template>

<script>
import SpriteAnim from "./SpriteAnim";

export default {
    name: "home-marketing-section",

    created() {
        window.tpx = this;
    },
    components: {
        SpriteAnim
    }
};
</script>

<style scoped>
.home-marketing-section {
    background-image: url("~@/assets/img/fondo_play_icons.png");
    background-color: #0083f5;
}
</style>
<style>
#senalandoTop {
    position: absolute;
    width: 100%;
    margin-top: -190px;
    margin-left: -200px;
    pointer-events: none;
}
#senalandoTop canvas {
    width: 300px;
    height: 300px;
    margin: auto;
}
</style>
